/* This example requires Tailwind CSS v2.0+ */
import React from "react"
import waterSplash from "../images/waterSplash.jpg"
const metrics = [
  {
    id: 1,
    stat: "7M ",
    emphasis: "Filipinos",
    rest: "rely on unsafe and unsustainable water sources.",
  },
  {
    id: 2,
    stat: "14",
    emphasis: "Persons on average",
    rest: "have died every single day in the past 10 years due to water-borne diseases.",
  },
  {
    id: 3,
    stat: "60%",
    emphasis: "Schools",
    rest: "do not achieve a basic service level of sanitation",
  },
  {
    id: 4,
    stat: "55% ",
    emphasis: "Schools",
    rest: "do not realise the basic service level of hygiene",
  },
]

export default function Impact() {
  return (
    <div className="relative bg-gray-900">
      <div className="h-80 w-full absolute bottom-0 xl:inset-0 xl:h-full">
        <div className="h-full w-full xl:grid xl:grid-cols-2">
          <div className="h-full xl:relative xl:col-start-2">
            <img
              className="h-full w-full object-cover opacity-70 xl:absolute xl:inset-0"
              src={waterSplash}
              alt="Water Splashing"
            />
            <div
              aria-hidden="true"
              className="absolute inset-x-0 top-0 h-32 bg-gradient-to-b from-gray-900 xl:inset-y-0 xl:left-0 xl:h-full xl:w-32 xl:bg-gradient-to-r"
            />
          </div>
        </div>
      </div>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:max-w-7xl lg:px-8 xl:grid xl:grid-cols-2 xl:grid-flow-col-dense xl:gap-x-8">
        <div className="relative pt-12 pb-64 sm:pt-24 sm:pb-64 xl:col-start-1 xl:pb-24">
          <p className="mt-3 text-3xl font-extrabold text-white">Why We Care</p>
          <div className="mt-12 grid grid-cols-1 gap-y-12 gap-x-6 sm:grid-cols-2">
            {metrics.map(item => (
              <p key={item.id}>
                <span className="block text-2xl font-bold text-white">
                  {item.stat}
                </span>
                <span className="mt-1 block text-base text-gray-300">
                  <span className="font-medium text-white">
                    {item.emphasis}
                  </span>{" "}
                  {item.rest}
                </span>
              </p>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
